import {obtenerIDLocal} from "./obtenerIDLocal";
import {doc, setDoc, updateDoc} from "firebase/firestore";
import {fire} from "../../fire";

export const registrarObjeto = async ({metrica, obj, coleccion = 'metricas'}) => {

    let uid = obtenerIDLocal()
    let referencia = doc(fire, coleccion, uid)

    try {
        await updateDoc(referencia, {[metrica]: obj});
    } catch (err) {
        await setDoc(referencia, {[metrica]: obj, id: uid});
    }

}